<template>
    <structure>
        <section class="load" v-if="load"></section>
        <section class="curriculo" v-if="!load">
            <div class="avatar">
                <img :src="infos.avatar">
            </div>
            <div class="infos">
                <div class="name">{{fullName}}</div>
                <div class="jobtitle">{{infos.jobtitle}}</div>
            </div>
            <div class="info-section">
                <h2>1 - Informações Pessoais:</h2>
                <div>
                    <strong>Sexo:</strong> {{infos.sexo}}
                </div>
                <div>
                    <strong>Data de Nascimento:</strong> {{infos.birthday | moment('DD/MM/YYYY')}}
                </div>
                <div>
                    <strong>Estado Civil:</strong> {{infos.marital_status}}
                </div>
                <div>
                    <strong>CPF:</strong> {{infos.cpf}}
                </div>
                <div>
                    <strong>RG:</strong> {{infos.rg}}
                </div>
            </div>
            <div class="info-section">
                <h2>2 - Contatos:</h2>
                <div>
                    <strong>Telefone Residencial:</strong> {{infos.phone}}
                </div>
                <div>
                    <strong>Celular:</strong> {{infos.mobile}}
                </div>
                <div>
                    <strong>E-mail:</strong> {{infos.email}}
                </div>
            </div>
            <div class="info-section">
                <h2>3 - Atuação Profissional:</h2>
                <div>
                    <strong>Área de atuação:</strong> {{infos.occupation}}
                </div>
                <div>
                    <strong>Função/Cargo:</strong> {{infos.jobtitle}}
                </div>
                <div>
                    <strong>Pretenção Salarial:</strong> {{infos.desired_salary}}
                </div>
                <div>
                    <strong>Habilidades Pessoais:</strong> {{infos.skills}}
                </div>
                <div>
                    <strong>Disponibilização:</strong> {{infos.availability}}
                </div>
                <div>
                    <strong>Objetivos:</strong> {{infos.goals}}
                </div>
            </div>
            <div class="info-section">
                <h2>4 - Formação Acadêmica:</h2>
                <div>
                    <strong>Formação:</strong> {{infos.schooling}}
                </div>
                <div>
                    <strong>Instituição de Ensino:</strong> {{infos.educational_institution}}
                </div>
                <div>
                    <strong>Curso:</strong> {{infos.course}}
                </div>
                <div>
                    <strong>Ano de Formação:</strong> {{infos.course_end_date | moment('DD/MM/YYYY')}}
                </div>
            </div>
            <div class="info-section">
                <h2>5 - Idiomas:</h2>
                <div>
                    <strong>Português:</strong> {{infos.portugues}}
                </div>
                <div>
                    <strong>Inglês:</strong> {{infos.ingles}}
                </div>
                <div>
                    <strong>Espanhol:</strong> {{infos.espanhol}}
                </div>
            </div>
            <div class="info-section">
                <h2>6 - Outras Informações:</h2>
                <div>
                    <strong>CNH:</strong> {{infos.cnh}}
                </div>
                <div>
                    <strong>Possui carro próprio?</strong> {{infos.own_car}}
                </div>
                <div>
                    <strong>Necessidades Especiais:</strong> {{infos.special_needs}}
                </div>
                <div>
                    <strong>Fumante:</strong> {{infos.smoker}}
                </div>
            </div>
            <div class="info-section">
                <h2>7 - Informações Extras:</h2>
                <div>
                    <strong>Cursos:</strong> {{infos.courses}}
                </div>
            </div>
            <div class="info-section">
                <h2>8 - Endereço:</h2>
                <div>
                    <strong>CEP:</strong> {{infos.cep}}
                </div>
                <div>
                    <strong>Estado:</strong> {{infos.uf}}
                </div>
                <div>
                    <strong>Cidade:</strong> {{infos.city}}
                </div>
                <div>
                    <strong>Bairro:</strong> {{infos.neighborhood}}
                </div>
                <div>
                    <strong>Endereço:</strong> {{infos.address}}
                </div>
                <div>
                    <strong>Complemento:</strong> {{infos.address_complement}}
                </div>
            </div>
            <div class="experience" v-if="infos.experiences">
                <h2>Experiência Profissional</h2>
                <div class="items">
                    <div class="item" v-for="experience in infos.experiences" :key="experience.id">
                        <div>
                            <strong>Empresa:</strong> {{experience.company_name}}
                        </div>
                        <div>
                            <strong>Cargo:</strong> {{experience.jobtitle}}
                        </div>
                        <div>
                            <strong>Salário:</strong> {{experience.salary}}
                        </div>
                        <div>
                            <strong>Cidade/Estado:</strong> {{experience.city}}
                        </div>
                        <div>
                            <strong>Atividades:</strong> {{experience.activies}}
                        </div>
                        <div>
                            <strong>Período:</strong> De {{experience.input_date | moment('DD/MM/YYYY')}} à {{experience.output_date | moment('DD/MM/YYYY')}}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </structure>
</template>

<script>
    import structure from '@/templates/private'
    import { profile } from '@/services'
    export default {
        name: 'login',
        components: { structure },
        data() {
            return {
                id: null,
                infos: {},
                load: false,
            }
        },
        computed: {
            fullName(){
                return this.infos.first_name + ' ' + this.infos.last_name
            }
        },
        methods: {
            
            getdata(){
                this.load = true
                profile.curriculum(this.id).then( response => {
                    this.infos = response.data
                    this.load = false
                })
            }
        },
        created(){
            this.id = this.$route.params.userid
            this.getdata()

        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
